/** @format */

import {useState} from 'react';

import Autocomplete from '@mui/material/Autocomplete';

import {Box} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import {styled} from '@mui/material/styles';

import LegacyTextField from 'components/inputs/LegacyTextField';

const FixedTextField = styled(Box)(({theme}) => ({
  position: 'relative',

  '.MuiFormControl-root .MuiInputBase-root': {
    padding: theme.spacing(2.25, 2.25, 2.25, 10.25),
  },
}));

interface OptionData {
  id: string;
  title: string;
}

interface Props<T> {
  options: T[];
  placeholder?: string;
  onChange: (option: T | null) => void;
  onStartTyping: () => void;
}

const AutocompleteField = <T extends OptionData>(props: Props<T>) => {
  const [startInteracting, setStartInteracting] = useState(false);
  return (
    <Autocomplete
      freeSolo
      options={props.options}
      getOptionLabel={option => (option as T).title}
      renderInput={params => (
        <FixedTextField>
          <LegacyTextField
            {...params}
            placeholder={props.placeholder}
            slotProps={{
              input: {
                ...params.InputProps,
                type: 'search',
                sx: {padding: '0 32px'},
              },
            }}
          />
          <SearchIcon
            sx={{
              color: '#8B8B8B',
              position: 'absolute',
              left: '16px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          />
        </FixedTextField>
      )}
      onChange={(_event, value, _reason, _details) => {
        if (typeof value === 'string') return;

        props.onChange(value);
      }}
      onInputChange={() => {
        if (!startInteracting) {
          props.onStartTyping();
          setStartInteracting(true);
        }
      }}
    />
  );
};

export default AutocompleteField;
